import React from "react";

export default function Section4() {
  return (
    <div className="bg-[#E8F2F4] text-[#0A2C84] px-6 md:px-20 lg:px-40 py-16 space-y-12">
      <div>
        <h2 className="text-2xl md:text-3xl font-bold mb-2 drop-shadow-sm">
          Consulta las opciones de conceptos cambiarios
        </h2>
        <p className="font-semibold text-[#2F6FE8] text-xl drop-shadow-sm">
          Comparte tus datos solo con entidades que cuenten con una Política de Terceros Receptores de Datos (TRD). Conoce la nuestra aquí:
        </p>
      </div>

      <div className="scroll-mt-24">
        <h3 className="text-3xl font-bold mb-6 drop-shadow-sm">Documentos</h3>
        <div className="flex flex-col md:flex-row gap-4">
          <button className="bg-[#0A2C84] text-white font-semibold px-6 py-3 rounded-full shadow-md">
            Comprobante de cobro de giros
          </button>
          <button className="bg-[#0A2C84] text-white font-semibold px-6 py-3 rounded-full shadow-md">
            Formato de Inscripción de producto para Abono Automático por Giros del Exterior
          </button>
        </div>
      </div>

      <div id="faq" className="scroll-mt-24">
        <h3 className="text-3xl font-bold mb-6 drop-shadow-sm">Preguntas frecuentes</h3>
        <div className="space-y-6 font-semibold text-[#2F6FE8] text-xl drop-shadow-sm">
          <div>
            <p className="text-[#0A2C84] font-bold drop-shadow-sm">
              ¿Los clientes personas jurídicas (PJ) pueden inscribirse al servicio?
            </p>
            <p className="drop-shadow-sm">No, el servicio está disponible únicamente para personas naturales (PN).</p>
          </div>
          <div>
            <p className="text-[#0A2C84] font-bold drop-shadow-sm">
              ¿Cuántas cuentas se pueden inscribir al servicio de abono automático?
            </p>
            <p className="drop-shadow-sm">Solo se puede inscribir una cuenta por cliente. Si un beneficiario tiene órdenes de pago pendientes se inscribe al servicio de abono automático.</p>
          </div>
        </div>
      </div>
    </div>
  );
}
